export const hosts = ['sweetspot.la', 'www.sweetspot.la'];
export const paths = ['/about', '/pricing', '/help', '/help/languages', '/help/order-button', '/help/photos', '/help/plans', '/help/publish', '/support', '/privacy', '/terms'];
export const project = 'z0a3nkz241';
